// eslint-disable-next-line
const truncate = require('truncate-utf8-bytes');
// TODO: possible replacement
// https://www.npmjs.com/package/sanitize-filename
export function sanitizeFilename(fileName: string, replacement = ''): string {
  // eslint-disable-next-line
  const illegalRe = /[\/\?<>\\:\*\|":]/g;
  // eslint-disable-next-line
  const controlRe = /[\x00-\x1f\x80-\x9f]/g;
  const reservedRe = /^\.+$/;
  const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
  // eslint-disable-next-line
  const windowsTrailingRe = /[\. ]+$/;
  const sanitizedFileName = fileName
    .replace(illegalRe, replacement)
    .replace(controlRe, replacement)
    .replace(reservedRe, replacement)
    .replace(windowsReservedRe, replacement)
    .replace(windowsTrailingRe, replacement);
  // eslint-disable-next-line
  return truncate(sanitizedFileName, 255);
}

function downloadFile(blob: Blob, fileName: string): void {
  const fileNameSanitized = sanitizeFilename(fileName);
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileNameSanitized;
  document.body.appendChild(link);
  link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  link.remove();
  window.URL.revokeObjectURL(link.href);
}

export function downloadFileByUrl(src: string | Blob, fileName: string): void {
  if (src && fileName) {
    if (typeof src === 'string') {
      fetch(src).then((r) =>
        r.blob().then((blob) => {
          downloadFile(blob, fileName);
        }),
      );
    } else {
      downloadFile(src, fileName);
    }
  } else {
    throw new Error('downloadFileByUrl: invalid url or fileName');
  }
}

export function getFilenameFromUrl(url: string): string | undefined {
  return new URL(url).pathname.split('/').pop();
}

export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve: (str: string) => unknown) => {
    const reader = new FileReader();
    reader.onloadend = (): unknown => (typeof reader.result === 'string' ? resolve(reader.result) : null);
    reader.readAsDataURL(blob);
  });
}

/* Converts base64 string to url acceptable by pdf viewer */
export function getPdfSrcUrl(base64Src: string): string | null {
  if (!base64Src) {
    return null;
  }
  const byteArray = new Uint8Array(
    atob(base64Src)
      .split('')
      .map((char) => char.charCodeAt(0)),
  );
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
}

export function getSvgSrcUrl(svgElement: SVGElement): string {
  const svgString = new XMLSerializer().serializeToString(svgElement);
  const blob = new Blob([svgString], { type: 'image/svg+xml' });
  return URL.createObjectURL(blob);
}
